import React, { useEffect, useState } from "react";
import LiquidContainer from "../../components/LiquidContainer";
import MainLanding from "./MainLanding";
import apiClient from "../../api/apiClient";
import FlightTicket from "../../components/FlightTicket";

const FlightData = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [flightData, setFlightData] = useState(null);

  // Format date helper
  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleString();
  };

  useEffect(() => {
    const fetchFlightData = async () => {
      try {
        const response = await apiClient.get("/flight_data/");
        const data = response.data;

        // console.log("Datos de vuelos:", data);

        setFlightData(data);
      } catch (err) {
        if (err.response?.status === 401 || err.response?.status === 403) {
          window.location.href = "/";
          return;
        }
        setError("Could not load flight data");
      } finally {
        setLoading(false);
      }
    };

    fetchFlightData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <MainLanding>
      <LiquidContainer
        backgroundColor="#efefefe0"
        ancho="85vw"
        alto="75vh"
        borderline="0px"
        boxSdw="none"
      >
        <div
          className="m-0 p-0"
          style={{
            height: "90%",
            width: "95%",
            overflowY: "scroll",
            overflowX: "hidden",
          }}
        >
          {flightData && (
          <>
            {/* OUTBOUND */}
            {flightData.outbound ? (

              <FlightTicket
                flightType={"OUTBOUND"}
                flightColor={"#007fff"}
                passenger={flightData.participant}
                date={flightData.outbound.departure_time}
                from={flightData.outbound.departure}
                to={flightData.outbound.arrival}
                flightNum={flightData.outbound.flight_number}
                departure={flightData.outbound.departure_time}
                arrival={flightData.outbound.arrival_time}
                seat={flightData.outbound.seat}

              />

                ) : (
                  <div className="mb-4 text-muted">
                    No outbound flight assigned.
                  </div>
                )}

                {/* RETURN */}
                {flightData.return ? (
                  <FlightTicket
                    flightType={"RETURN"}
                    flightColor={"#ec0068"}
                    passenger={flightData.participant}
                    date={flightData.return.departure_time}
                    from={flightData.return.departure}
                    to={flightData.return.arrival}
                    flightNum={flightData.return.flight_number}
                    departure={flightData.return.departure_time}
                    arrival={flightData.return.arrival_time}
                    seat={flightData.return.seat}

                  />
                ) : (
                  <div className="text-muted">
                    No return flight assigned.
                  </div>
                )}
              </>
            )}
        </div>
      </LiquidContainer>
    </MainLanding>
  );
};

export default FlightData;